export default "__VITE_ASSET__BpNaorpD__"